import { createComponent, IntrinsicProps, toClassName } from '@common/util/templateHelpers';
import { LegacyRef, useEffect, useRef } from 'react';

const Ad = createComponent('Ad', {}, function Ad ({ className }, props) {
  return (
    <div id={props.id} className={className}>{props.children}</div>
  );
});
export default Ad; 

/* --- */

export enum AdContainerSize {
  BANNER = 'banner',
  MOBILE_BANNER = 'mobileBanner',
  HALF_PAGE = 'halfPage',
  LARGE_LEADERBOARD = 'largeLeaderboard',
  LARGE_RECT = 'largeRect',
  LEADERBOARD = 'leaderboard',
  MEDIUM_RECT = 'mediumRect',
  MOBILE_LEADERBOARD = 'mobileLeaderboard',
  SKYSCRAPER = 'skyscraper',
  SMALL_SQUARE = 'smallSquare',
  SQUARE = 'square',
  WIDE_SKYSCRAPER = 'wideSkyscraper'
}

interface AdContainerProps extends IntrinsicProps {
  banner?: boolean
  mobileBanner?: boolean
  halfPage?: boolean
  inlineRect?: boolean
  largeLeaderboard?: boolean
  largeRect?: boolean
  leaderboard?: boolean
  mediumRect?: boolean
  mobileLeaderboard?: boolean
  skyscraper?: boolean
  smallSquare?: boolean
  square?: boolean
  wideSkyscraper?: boolean
  size: AdContainerSize
  onAdblockDetected?: () => void
}

const adContainerClassStates = [
  'banner',
  'mobileBanner',
  'halfPage',
  'inlineRect',
  'largeLeaderboard',
  'largeRect',
  'leaderboard',
  'mediumRect',
  'mobileLeaderboard',
  'skyscraper',
  'smallSquare',
  'square',
  'wideSkyscraper'
];

export const AdContainer = createComponent<AdContainerProps>('AdContainer', 
  {}, 
  function AdContainer ({ mergeClassNames, style }, props) {
    const className = mergeClassNames(toClassName('AdContainer', adContainerClassStates, { [ props.size ]: true }));

    const containerRef = useRef(null);

    useEffect(() => {
      if(typeof props.onAdblockDetected !== 'function') {
        return;
      }

      const t = setTimeout(() => {
        // window.getComputedStyle gets very cranky if it gets a null-ish first
        // paramter, so make extra sure it doesn't run.
        if(!containerRef.current) {
          return;
        }

        if(window?.getComputedStyle(containerRef.current)?.display === 'none') {
          props.onAdblockDetected();
        }
      }, 1500);

      // If the component gets unmounted after initialization, we want to clear
      // the timeout so it doesn't run.
      return () => clearTimeout(t);
    }, []);

    return (
      <div className={className} style={style} ref={containerRef}>
        {props.children}
      </div>
    );
  });
